import React from 'react';
import {NavigationBar, Layout} from "./layout"
import { Typography, Box, Stack } from "@mui/material";
import Table from 'react-bootstrap/Table';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const AvatamsakaSutraContent = () => {
  const [value, setValue] = React.useState(0);

  const banner=(
    <div className="flex items-center justify-center my-6">
      <div className="relative border border-gray-500 rounded-lg p-3 bg-white shadow-lg flex items-center">
        <div className="absolute top-1/2 left-0 w-32 border-t border-gray-500 transform -translate-y-1/2" />
        <div className="px-8 py-2 bg-gray-100 border border-gray-500 rounded-lg shadow-md text-xl font-serif text-black relative z-10">
          華嚴經
        </div>
        <div className="absolute top-1/2 right-0 w-32 border-t border-gray-500 transform -translate-y-1/2" />
      </div>
    </div>
  );

  return (
    <><NavigationBar/>
      {/* Hero Image */}
<div style={{ display: "grid" }}>
      <img
        style={{
          gridArea: "1/1",
          // maxHeight: 600,
        }}
        layout="fullWidth"
        aspectRatio={3 / 1}
        alt=""
        src="/1337938998.jpg"
        />
      <div
        style={{
          gridArea: "1/1",
          position: "relative",
          placeItems: "center",
          display: "grid",
        }}
      >
      </div>
    </div>
    {/* Main Content */}
  <Layout>
  <img src="/avatamsaka.png" />
    <div>
      <Typography variant="h3">華嚴經 第一章 講解</Typography>
      <hr/>
<Table><tbody><tr><td>
<Typography variant="h6">下載音頻</Typography></td><td>
<Typography variant="h6">下載講義</Typography></td></tr>

</tbody></Table>
  <Box sx={{ width: '100%' }}>
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={value} onChange={(event, newValue) => {
    setValue(newValue);
  }} aria-label="basic tabs example">
        <Tab label="1-30講"  />
        <Tab label="31-60講"  />
      </Tabs>
    </Box>
    <CustomTabPanel value={value} index={0}>
    <Table><tbody><tr><td><ul>
      <li>
        <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Chapter01/01_AvatamsakaSutra_20211024.mp3">
          2021年10月24日 - 華嚴經 第一章 第01講
        </a>
      </li>
      <li>
        <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Chapter01/02_AvatamsakaSutra_20211031.mp3">
          2021年10月31日 - 華嚴經 第一章 第02講
        </a>
      </li>
      <li>
        <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Chapter01/03_AvatamsakaSutra_20211107.mp3">
          2021年11月07日 - 華嚴經 第一章 第03講
        </a>
      </li>
      <li>
        <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Chapter01/04_AvatamsakaSutra_20211121.mp3">
          2021年11月21日 - 華嚴經 第一章 第04講
        </a>
      </li>
      <li>
        <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Chapter01/05_AvatamsakaSutra_20211128.mp3">
          2021年11月28日 - 華嚴經 第一章 第05講
        </a>
      </li>
      <li>
        <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Chapter01/06_AvatamsakaSutra_20211205.mp3">
          2021年12月05日 - 華嚴經 第一章 第06講
        </a>
      </li>
    </ul>
    </td><td><ul>
      <li>
        <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Chapter01/AvatamsakaSutra_Chapter01_Part1_1of2.pdf">
          華嚴經 第一章 第1部分 (1之2) 講義
        </a>
      </li>
      <li>
        <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Chapter01/AvatamsakaSutra_Chapter01_Part1_2of2.pdf">
          華嚴經 第一章 第1部分 (2之2) 講義
        </a>
      </li>
    </ul></td></tr>

    </tbody></Table>
    </CustomTabPanel>
    <CustomTabPanel value={value} index={1}>
    </CustomTabPanel>
  </Box>

      <section>
      <Typography variant="h3">華嚴經疏加評註 講解</Typography>
      <hr/>
<Table><tbody><tr><td>
<Typography variant="h6">下載音頻</Typography></td><td>
<Typography variant="h6">下載講義</Typography></td></tr>

</tbody></Table>
<Box sx={{ width: '100%' }}>
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
    <Tabs value={0}  aria-label="basic tabs example">
      <Tab label="1-30講"  />
    </Tabs>
  </Box>
  <CustomTabPanel value={0} index={0}>
  <Table><tbody><tr><td>
        <ul>
          <li>
            <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Prologue/02_AvatamsakaSutra_20201107.mp3">
              2020年11月07日 - 華嚴經 序論 第02講
            </a>
          </li>
          <li>
            <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Prologue/04_AvatamsakaSutra_20201121.mp3">
              2020年11月21日 - 華嚴經 序論 第04講
            </a>
          </li>
          <li>
            <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Prologue/05_AvatamsakaSutra_20201212.mp3">
              2020年12月12日 - 華嚴經 序論 第05講
            </a>
          </li>
          <li>
            <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Prologue/07_AvatamsakaSutra_20201226.mp3">
              2020年12月26日 - 華嚴經 序論 第07講
            </a>
          </li>
          <li>
            <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Prologue/09_AvatamsakaSutra_20210109.mp3">
              2021年01月09日 - 十身 六位 第09講
            </a>
          </li>
          <li>
            <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Prologue/11_AvatamsakaSutra_20210123.mp3">
              2021年01月23日 - 十波羅蜜 第11講
            </a>
          </li>
        </ul>
</td><td>
        <ul>
          <li>
            <a href="https://s3-us-west-1.amazonaws.com/chanpureland/AvatamsakaSutra/Prologue/AvatamsakaSutra_Prologue.pdf">
              華嚴經 序論 講義
            </a>
          </li>
        </ul>
      </td></tr></tbody></Table>    </CustomTabPanel></Box></section>

    </div>
    </Layout></>
  );
};

export default AvatamsakaSutraContent;
